"use client";
import "../../../../chunk-MMUBH76A.js";
import { useEffect, useState } from "react";
const useDropdownPosition = (inputRef) => {
  const [dropdownMaxHeight, setDropdownMaxHeight] = useState();
  const [dropdownWidth, setDropdownWidth] = useState();
  const [mobileAnchor, setMobileAnchor] = useState();
  const resize = () => {
    var _a, _b, _c;
    if (typeof window !== "undefined") {
      const newMaxHeight = Math.max(
        window.innerHeight - ((_a = inputRef == null ? void 0 : inputRef.current) == null ? void 0 : _a.getBoundingClientRect().bottom) - 20,
        window.innerHeight * 0.25
      );
      setDropdownMaxHeight(newMaxHeight);
      setDropdownWidth((_b = inputRef == null ? void 0 : inputRef.current) == null ? void 0 : _b.getBoundingClientRect().width);
      setMobileAnchor((_c = inputRef == null ? void 0 : inputRef.current) == null ? void 0 : _c.getBoundingClientRect().height);
    }
  };
  if (inputRef.current && !dropdownMaxHeight) {
    resize();
  }
  useEffect(() => {
    typeof window !== "undefined" && window.addEventListener("resize", resize);
    return () => {
      typeof window !== "undefined" && window.removeEventListener("resize", resize);
    };
  }, []);
  return { dropdownMaxHeight, dropdownWidth, mobileAnchor, resize };
};
export {
  useDropdownPosition
};
